/*  =============================================
    Copyright © Hugo B.V. (acting under the brand name "Quriobot") - All Rights Reserved
    =============================================

    - Unauthorized copying of this file, via any medium is strictly prohibited
    - Proprietary and confidential
    - By using the Quriobot Website and/or Services, you signify you have read and
      accepted the Terms of Service on https://quriobot.com/terms of this Website and Services.
      If you do not agree to these Conditions, do not use Quriobot Website and/or Services.
    - Written by the good people of Hugo B.V. (acting under the brand name "Quriobot"), hello@quriobot.com, December 2016

    ============================================= */

var QuriobotElement = new Class({
  Implements: [Locales, FoldOut, IO],
  initialize: function (args, naturalDelayConfig) {
    this.data = args[0]
    this.data.eid = args[1]
    this.data.start = new Date().toISOString()
    this.parent = $('conversation')
    this.inputContainer = $('input--container')
    this.parent_after = $('after')
    this.api = this.data.api
    this.renderCallback = args[2]
    this.answerCallback = args[3]
    this.errorCallback = args[4]
    this.viewCallback = args[5]
    this.redoCallback = args[6]
    this.againCallback = args[7]
    this.after = FunctionUtilities.once(this.after)
    // Set natural delay for bot messages
    // if chat message has custom delay set custom delay, otherwise set default
    if (this.data.type === 'bot' && typeof this.data.str === 'object' && this.data.str.delay) {
      this.setNaturalDelayConfig(this.data.str.delay)
    } else {
      this.setNaturalDelayConfig(naturalDelayConfig)
    }

    if (args[8]) {
      this.apiCallback = args[8]
    }
    if (args[9]) {
      this.populateCallback = args[9]
    }
    if (args[10]) {
      this.getOptionsCallback = args[10]
    }
    if (args[11]) {
      this.validateAnswerCallback = args[11]
    }
    if (args[12]) {
      this.getSettingsScriptCallback = args[12]
    }
    if (args[13]) {
      this.quriobot = args[13]
    }
    if (this.data.html) {
      this.addToDom_build(this.data.html)
    } else {
      if (this.data.savedValue) {
        this.renderCallback(this.data, this.data.eid, true)
        this.handlePrefilled()
        return
      }
      if (!$(this.data.eid)) {
        this.addToDom()
      } else {
        this.in(true)
      }
    }
  },
  template: function () {
    /* html content for items */
  },
  openURL: function (url, target) {
    if (url) {
      switch (target) {
        case '_top':
          window.top.location.href = url
          break
        case '_parent':
        case '_self':
          window.parent.location.href = url
          break
        default:
          return window.open(url)
      }
    }
  },
  populate: function (result) {
    if (result) {
      this.addToDom(result)
      return
    }

    /* populate content */
    var base = this.template().base
    var options = ''

    // If val null or undefined replace with empty string
    var checkVal = function (val) {
      if (val === null || typeof val === 'undefined') {
        return ''
      }
      return val
    }

    if (this.data.type == 'bot' && typeOf(this.data.str).toLowerCase() == 'object') {
      var base = this.template()[this.data.str.display_as] || this.template().base
      Object.each(
        this.data.str,
        function (val, key) {
          var regex = '{{ ' + key.toString().trim() + ' }}'
          base = base.replace(new RegExp(regex, 'gi'), checkVal(val))
        }.bind(this)
      )
    } else {
      var base = this.template().base
    }

    Object.each(
      this.data,
      function (val, key) {
        var regex = '{{ ' + key.toString().trim() + ' }}'
        base = base.replace(new RegExp(regex, 'gi'), checkVal(val))
      }.bind(this)
    )

    // loop through
    if (this.data.type.name === 'rating') {
      if (this.data.choices) {
        for (var i = 0; i < this.data.choices; i++) {
          var templateOption = this.template().option
          if (templateOption) {
            options += Mustache.render(templateOption, { index: i, number: i + 1 })
          }
        }
      }
    } else if (this.data.options && typeOf(this.data.options).toLowerCase() == 'array') {
      (this.data.randomize_options ? this.data.options.slice().shuffle() : this.data.options).each(
        function (item) {
          if (item.image_before) {
            if (!(item.image_before.indexOf('http') === 0) && !(item.image_before.indexOf('/') === 0)) {
              item.image_before = '/static/quriobot/assets/options/' + item.image_before
            }
          }
          if (['options', 'images', 'image_autocomplete'].indexOf(this.data.type.name) === -1) {
            item.comment = ''
          }
          options += Mustache.render(this.template().option || this.template().base || '', item)
        }.bind(this)
      )
      // use it as a settings variable
    } else if (this.data.options && typeOf(this.data.options).toLowerCase() == 'object') {
      var items = Object.keys(this.data.options)
      ;(this.data.randomize_options ? items.shuffle() : items).each(
        function (key) {
          var val = this.data.options[key]
          if (val && this.template()[key]) {
            options += this.template()[key].replace(/{{\s*str\s*}}/gi, checkVal(val))
          }
        }.bind(this)
      )
    }

    base = base.replace(/{% options %}/g, options)

    if (
      (this.data.choices && this.data.choices > 1) || // Enable button for the multipleChoice
      (this.data.is_required === false && this.data.type.name !== 'yesno_display') ||
      (this.data.meta && this.data.meta.displayType === 'window') || // Show button for foldout
      (this.data.meta && this.data.meta.isDateTime) || // Enable button for datePicker
      this.data.type.name === 'time' || // Enable button for time picker
      this.data.type.name === 'birthdate' || // Enable button for birthdate
      this.data.type.name === 'datetime_range' || // Enable button for range datePicker
      this.data.type.name === 'file' // Enable button for range datePicker
    ) {
      base = base.replace(/{% button %}/g, this.template().button)
      base = base.replace(/{% button-state %}/g, ' hasButton')
      base = base.replace(/{% button-text %}/g, this.data.meta.done || 'done')
    } else {
      base = base.replace(/{% button %}/g, '')
      base = base.replace(/{% button-state %}/g, '')
    }

    if (this.data.meta) {
      Object.each(this.data.meta, function (val, key) {
        var regex = '{% ' + key.toString().trim() + ' %}'
        base = base.replace(new RegExp(regex, 'gi'), checkVal(val))
      })
    }

    if (this.data) {
      Object.each(this.data, function (val, key) {
        var regex = '{% ' + key.toString().trim() + ' %}'
        base = base.replace(new RegExp(regex, 'gi'), checkVal(val))
      })
    }

    this.populateValues(base)
  },
  populateFromApi: function (name, data) {
    var base = data.data.base
    var content = data.data.content.toString()
    var html = base.replace('{%' + name + '%}', content)
    return html
  },
  populateAnswer: function (callback, base, data) {
    if (!data) {
      this.parent.fireEvent('fetchData', {
        request: ['_State'],
        base: base,
        resultsCallback: this.populateAnswer.bind(this, callback),
      })
      return
    }
    this.populateCallback(base, callback)
  },
  populateValues: function (base, data) {
    if (!data) {
      this.parent.fireEvent('fetchData', {
        request: ['_State'],
        base: base,
        resultsCallback: this.populateValues.bind(this),
      })
      return
    }
    if (this.populateCallback) {
      this.populateCallback(base, this.populate.bind(this))
    } else {
      this.populate(base)
    }
  },
  addToDom_build: function (newElement) {
    if (newElement === true) {
      return
    }
    newElement.inject(this.parent_after, 'before')
    this.in(true)
  },
  addToDom: function (newElement) {
    if (newElement) {
      $('botSpinner').addClass('bot--spinner__loading')
      this.parent_after.appendHTML(newElement, 'before')
      this.in()
      return
    }
    $('botSpinner').removeClass('bot--spinner__loading')
    this.populate()
  },
  attach: function () {
    /* add functions to elements */
  },
  attachRedo: function () {
    if (this.element.getElements('.redo').length > 0) {
      var redoButtons = this.element.getElements('.redo')
      redoButtons.each(
        function (button, i) {
          button.getParent().addEvents({
            click: function () {
              if (!this.element.hasClass('product')) {
                this.redoCallback(this.data, this.element)
              } else {
                var relink = this.parent.getElements('.panel--anchor:[family=' + this.data.key + ']')
                var relinkButton = relink.getElements('.redo--x')[0]
                relinkButton.fireEvent('click')
              }
            }.bind(this),
          })
        }.bind(this)
      )
    } else {
      return
    }

    if (this.element.hasClass('by--user')) {
      this.element.addEvents({
        click: function (e) {
          if (!e.target.hasClass('redo') && !e.target.hasClass('icon--redoWrapper')) {
            this.element.toggleClass('redo--ready')
          }
        }.bind(this),
      })
    }
  },
  setAriaHidden: function (el, value) {
    var foundEl = this.element.getElements(el)[0]
    if (foundEl) {
      foundEl.set('aria-hidden', value)
    }
  },
  handlePrefilled: function () {
    /* add standard response for this situation */
    if (!this.data.savedValue.render) {
      var answerData = {
        answer: {
          value: this.data.savedValue.value,
          content: this.data.savedValue.value,
          render: false,
        },
      }
      this.answerCallback(this.data, answerData, true)
    } else {
      var answerData = {
        answer: {
          value: this.data.savedValue.value,
          content: this.data.savedValue.value,
          render: 'default',
        },
      }
      this.answerCallback(this.data, answerData, true)
    }
  },
  after: function () {
    /* add callbackresponse */
  },
})
